import React, { useState, useEffect } from 'react';
import { Column } from '@ant-design/plots';
import Loader from '../../../utils/Loader';

const SummaryBarChart = ({ summaryReport, loading }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (summaryReport) {
      const chartData = summaryReport.rows;
      setConfig(chartData);
    }
  }, [summaryReport]);
  return (
    <div
      className={`${
        summaryReport && summaryReport.colCount ? summaryReport.colCount : ''
      } mb-3`}
    >
      {loading && <Loader />}
      {config && config.data ? <Column {...config} /> : null}
    </div>
  );
};

export default SummaryBarChart;

// console.log('summaryReport')
// useEffect(() => {
//   if (summaryReport) {
//     const rows = summaryReport.rows || [];
//     const mapData = summaryReport.columns.map((column, idx) => {
//       return {
//         type: column.label,
//         value: rows[0][column.field],
//         index: idx,
//       };
//     });
//     setBarData(mapData);
//   }
// }, [summaryReport]);

// // console.log('barData', barData);
// function getRandomNumberBetween(min, max) {
//   return Math.floor(Math.random() * (max - min + 1) + min);
// }
// const colors = [
//   'rgba(96, 209, 126)',
//   'rgba(250, 140, 92)',
//   'rgba(69, 175, 237)',
//   'rgba(124, 92, 219, 0.8)',
//   'rgba(206, 92, 219, 0.8)',
//   'rgba(219, 92, 151, 0.8)',
//   'rgba(159, 201, 52, 0.8)',
//   'rgba(252, 186, 3, 0.8)',
//   'rgba(96, 209, 126)',
//   'rgba(250, 140, 92)',
//   'rgba(69, 175, 237)',
//   'rgba(124, 92, 219, 0.8)',
//   'rgba(206, 92, 219, 0.8)',
//   'rgba(219, 92, 151, 0.8)',
//   'rgba(159, 201, 52, 0.8)',
//   'rgba(252, 186, 3, 0.8)',
// ];
// const brandColor = '#5B8FF9';
// const config = {
//   data: barData,
//   xField: 'type',
//   yField: 'value',
//   seriesField: 'index',
//   height: 300,

//   color: ({ index }) => {
//     const randIndex = getRandomNumberBetween(0, 15);
//     // console.log('type', type);
//     if (index < 1000) {
//       return colors[randIndex];
//     }

//     return brandColor;
//   },
//   // label: {
//   //   content: (originData) => {
//   //     const val = parseFloat(originData.value);

//   //     if (val < 0.05) {
//   //       return (val * 100).toFixed(1) + '%';
//   //     }
//   //   },
//   //   offset: 10,
//   // },
//   // autoFit: true,
//   legend: false,
//   xAxis: {
//     label: {
//       autoHide: true,
//       autoRotate: false,
//     },
//   },
// };

// console.log('summaryReport', summaryReport);
